/**
 * Web-compatible React Navigation Hooks
 * Provides web alternatives for React Navigation hooks
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Web-compatible useFocusEffect
 * On web, this runs on every route change
 */
export const useFocusEffect = (callback) => {
  const location = useLocation();
  
  useEffect(() => {
    // Run callback when component mounts or route changes
    callback();
  }, [location.pathname]);
};

/**
 * Web-compatible useIsFocused
 * On web, component is always "focused" when mounted
 */
export const useIsFocused = () => {
  return true;
};

// Re-export for compatibility
export default {
  useFocusEffect,
  useIsFocused,
};
